<template>
	<div id="registration-modal">
		<SwitchLanguage />
		<form @submit.prevent="onSubmit">
			<input ref="registrationEmailInput" type="text" name="registration-email-input" :placeholder="$t('user.inputYourEmail')" v-model="email" required>
			<input type="password" name="registration-password-input" :placeholder="$t('user.password')" v-model="password" required>
			<label @click="checked = !checked">
				<span class="fake-checkbox"><span class="checked" v-if="checked"></span></span>
				Souhlasím s <a href="https://mangozpevnik.cz/obchodni-podminky" target="_blank">obchodními podmínkami</a> a se <a href="https://mangozpevnik.cz/ochrana-osobnich-udaju" target="_blank">zpracováním osobních údajů</a>.
			</label>
			<button type="submit" class="registration-submit">{{ $t('user.registrationButton') }}</button>
		</form>
		<!--<div class="or">nebo</div>
		<button type="button" class="facebook" @click="onFacebook">Registrovat přes Facebook</button>-->
	</div>
</template>

<script>
	import Vue from "vue";
	import { auth } from "@/firebase";
	import firebase from "firebase";
	import { UserService } from "@/services/UserService";
	import SwitchLanguage from "../language/SwitchLanguage";

	export default {
		name: "RegistrationTab",
		components: {SwitchLanguage},
		data() {
			return {
				email: null,
				password: null,
				checked: false
			};
		},
		methods: {
			opened() {
				Vue.nextTick(() => {
					this.$refs.registrationEmailInput.focus();
				});
			},
			onSubmit() {
				if (this.$store.state.networkOnline !== true) {
					this.$notify({
						type: "error",
						text: "Zkontrolujte, prosím, své připojení k internetu.",
					});
					return;
				}

				if (this.checked === false) {
					this.$notify({
						type: "error",
						text: "Musíte zaškrtnout svůj souhlas s obchodními podmínkami.",
					});
					return;
				}

				this.$store.commit("setLoading", true);

				var credential = firebase.auth.EmailAuthProvider.credential(this.email, this.password);

				auth.currentUser.linkAndRetrieveDataWithCredential(credential)
					.then(() => {
						/* eslint-disable */ ga("send", "event", "Sign up", "submit");
						fbq("track", "CompleteRegistration");
						gtag('event', 'conversion', {'send_to': 'AW-738715813/VwYpCKXgq8IDEKXRn-AC'});

						this.$store.commit("setLoading", false);
						this.$modal.hide("login-registration");
						this.$modal.hide("login-registration-force");
						this.$notify({
							type: "success",
							text: "Jsi úspěšně zaregistrován.",
						});
						UserService.registrationUserInfo();
					})
					.catch((error) => {
						this.$store.commit("setLoading", false);
						if (error.code === "auth/weak-password") {
							this.$notify({
								type: "error",
								text: "Heslo musí mít alespoň 6 znaků.",
							});
						}

						if (error.code === "auth/invalid-email") {
							this.$notify({
								type: "error",
								text: "Přihlašovací e-mail není validní.",
							});
						}

						if (error.code === "auth/email-already-in-use") {
							this.$notify({
								type: "error",
								text: "Uživatel s tímto e-mailem již existuje. Přihlaste se.",
							});
						}
					});
			},
			onFacebook() {
				var provider = new firebase.auth.FacebookAuthProvider();
				auth.signInWithPopup(provider).then(() => {
					this.$modal.hide("registration");
					//var token = result.credential.accessToken;
					//var user = result.user;
				}).catch(function(error) {
					//var errorCode = error.code;
					//var errorMessage = error.message;
					//var email = error.email;
					//var credential = error.credential;
					alert(error.message);
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	#registration-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		.or {
			text-align: center;
			margin-bottom: 20px;
		}

		input {
			width: 87%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background-color: rgba(255, 255, 255, 0.21);
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin-bottom: 1px;

			&::placeholder {
				color: rgba(255, 255, 255, 0.49);
			}

			&:focus {
				outline: none;
			}
		}

		button.registration-submit {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}

		button.facebook {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0 1px 0;
			cursor: pointer;

			background-color: #4267b2;
			color: #e0e2f7;
			display: block;
			text-align: center;
			font-size: 1.2em;

			&:hover {
				background-color: #3a5b9d;
			}
		}

		label {
			margin: 20px 20px 7px 20px;
			font-size: 0.7em;
			line-height: 1.4em;
			padding: 0;
			display: block;
			cursor: pointer;

			span.fake-checkbox {
				display: inline-block;
				width: 12px;
				height: 12px;
				border-radius: 4px;
				border: 1px solid rgba(255, 255, 255, 0.71);

				span.checked {
					background-color: rgb(233,196,106);
					width: 8px;
					height: 8px;
					padding: 0;
					display: block;
					margin: 2px auto;
					border-radius: 2px;
				}
			}

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}

	}
</style>
